export default __webpack_public_path__ + "images/amazon-logo.395751346acea7445a4433f973b040b3.png";